import { helpers } from 'vuelidate/lib/validators'

const fileSize = param =>
  helpers.withParams({ type: 'fileSize', value: param }, (value, group) => {
    return value.size >= param.min * 1024 && value.size <= param.max * 1024
  })

export default fileSize
